/* KAAFEY — scroll-motion (onthullen, onderstrepen, tellers). Progressive enhancement: zonder JS blijft alles gewoon zichtbaar. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var d = document, reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  d.documentElement.classList.add('k-motion');

  /* Woorden onderstrepen: accent-woorden in koppen krijgen een span die "getekend" wordt */
  d.querySelectorAll('.kaafey-site h1 em, .kaafey-site h2 em').forEach(function (em) {
    if (em.querySelector('.k-ul')) return;
    var s = d.createElement('span'); s.className = 'k-ul';
    while (em.firstChild) s.appendChild(em.firstChild);
    em.appendChild(s);
  });

  /* Elementen die inspringen bij scrollen, met kleine vertraging per kind */
  var groups = ['.hero-copy', '.feature-bar', '.section-head', '.offer-copy', '.box-copy', '.uses-copy', '.detail-grid', '.choice-grid', '.compare-mobile', '.service-grid', '.faq-list', '.closing', '.assurance', '.check-list', '.box-list', '.spec-list', '.kaafey-page-body'];
  var items = [];
  groups.forEach(function (sel) {
    d.querySelectorAll(sel).forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (c, i) {
        if (c.classList.contains('k-reveal')) return;
        c.classList.add('k-reveal');
        c.style.setProperty('--d', (Math.min(i, 8) * 0.07) + 's');
        items.push(c);
      });
    });
  });
  var uls = Array.prototype.slice.call(d.querySelectorAll('.k-ul'));

  function show(el) {
    el.classList.add('is-in');
    el.querySelectorAll('.k-ul').forEach(function (u) { u.classList.add('is-in'); });
  }
  if (reduce) { items.forEach(show); uls.forEach(show); return; }

  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  var vh = window.innerHeight || 800;
  items.forEach(function (el) {
    /* alles dat al in beeld staat (hero) direct tonen, zodat niets afhankelijk is van de observer-timing */
    if (el.getBoundingClientRect().top < vh * 1.05) { show(el); return; }
    io.observe(el);
  });
  uls.forEach(function (u) { if (!u.closest('.k-reveal')) io.observe(u); });

  /* Tellers: cijfers in de detailkaarten (bar, gram) tellen op */
  d.querySelectorAll('.detail-number').forEach(function (el) {
    var node = el.firstChild;
    if (!node || node.nodeType !== 3) return;
    var m = node.textContent.match(/^\s*(\d+)/);
    if (!m) return;
    var target = +m[1];
    var co = new IntersectionObserver(function (es) {
      if (!es.some(function (e) { return e.isIntersecting; })) return;
      co.disconnect();
      var t0 = performance.now(), dur = 1100;
      var set = function (v) { node.textContent = node.textContent.replace(/^\s*\d+/, v); };
      (function step(now) {
        var p = Math.min(1, (now - t0) / dur);
        set(Math.round(target * (1 - Math.pow(1 - p, 3))));
        if (p < 1) requestAnimationFrame(step);
      })(t0);
      setTimeout(function () { set(target); }, dur + 150); /* vangnet (verborgen tab, throttling) */
    }, { threshold: 0.5 });
    co.observe(el);
  });
})();
